import React from "react";
import InputField from "components/fields/InputField";

const Title = (props) => {
  const { updateName, errors, register } = props;

  return (
    <>
      <InputField
        extra="mb-3"
        label={`${
          updateName.charAt(0).toUpperCase() + updateName.slice(1)
        } (EN)*`}
        id={`${updateName}_en`}
        type="text"
        name={`${updateName}_en`}
        errors={errors}
        register={register}
        defaultValue={""}
        validationSchema={{
          required: `${
            updateName.charAt(0).toUpperCase() + updateName.slice(1)
          } (EN) harus diisi!`,
        }}
      />
      <InputField
        extra="mb-3"
        label={`${
          updateName.charAt(0).toUpperCase() + updateName.slice(1)
        } (ID)*`}
        id={`${updateName}_id`}
        type="text"
        name={`${updateName}_id`}
        errors={errors}
        register={register}
        defaultValue={""}
        validationSchema={{
          required: `${
            updateName.charAt(0).toUpperCase() + updateName.slice(1)
          } (ID) harus diisi!`,
        }}
      />
    </>
  );
};

export default Title;
